import request from '@/utils/request'

const ssoLoginApi = {
  ssoLogin: data => {
    return request({
      url: '/auth/ciam/login',
      method: 'post',
      data
    })
  },
  authLogout: data => {
    return request({
      url: '/auth/logout',
      method: 'post',
      data
    })
  }
}

export default ssoLoginApi
